import axios from 'axios'

const state = {
  accountInfo: null,
  usage: null,
  plans: []
}

const getters = {
  accountInfo: state => state.accountInfo,
  usage: state => state.usage,
  plans: state => state.plans
}

const mutations = {
  SET_ACCOUNT_INFO(state, accountInfo) {
    state.accountInfo = accountInfo
  },
  SET_USAGE(state, usage) {
    state.usage = usage
  },
  SET_PLANS(state, plans) {
    state.plans = plans
  }
}

const actions = {
  // Fetch user account information
  async fetchAccountInfo({ commit }) {
    try {
      const response = await axios.get('/api/account/info')
      commit('SET_ACCOUNT_INFO', response.data)
      return response.data
    } catch (error) {
      throw error
    }
  },
  
  // Fetch usage data (call minutes, SMS, data usage)
  async fetchUsage({ commit }) {
    try {
      const response = await axios.get('/api/account/usage')
      commit('SET_USAGE', response.data)
      return response.data
    } catch (error) {
      throw error
    }
  },
  
  // Fetch available plans
  async fetchPlans({ commit }) {
    try {
      const response = await axios.get('/api/account/plans')
      commit('SET_PLANS', response.data)
      return response.data
    } catch (error) {
      throw error
    }
  },
  
  // Update user profile
  async updateProfile({ commit }, profileData) {
    try {
      const response = await axios.put('/api/account/profile', profileData)
      commit('SET_ACCOUNT_INFO', response.data)
      return response.data
    } catch (error) {
      throw error
    }
  },
  
  // Change plan
  async changePlan({ commit, dispatch }, planId) {
    try {
      const response = await axios.post('/api/account/change-plan', { planId })
      // Refresh account info after plan change
      await dispatch('fetchAccountInfo')
      return response.data
    } catch (error) {
      throw error
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}